import React from 'react';
import './AccessDenied.css';

/**
 * Access Denied Page - User Friendly Version
 * Shown when user doesn't have valid authentication
 * Redirects to OneClick Trading login
 */
function AccessDenied({ error }) {
  const handleLoginClick = () => {
    window.location.href = 'https://app.oneclicktrading.com';
  };

  return (
    <div className="access-denied">
      <div className="access-denied-container">
        <div className="access-denied-icon">👋</div>

        <h1 className="access-denied-title">Alpha Edge</h1>

        <p className="access-denied-message">
          Sign in with your OneClick Trading account to access your dashboard.
        </p>

        <button className="access-denied-btn" onClick={handleLoginClick}>
          <span className="btn-icon">✨</span>
          <span>Sign In to OneClick Trading</span>
          <span className="btn-arrow">→</span>
        </button>

        <div className="benefits-section">
          <div className="benefit-item">
            <span className="benefit-icon">📊</span>
            <span className="benefit-text">Live Tracking</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">🎯</span>
            <span className="benefit-text">Real-Time Alerts</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">⚡</span>
            <span className="benefit-text">Analytics</span>
          </div>
        </div>

        <p className="help-text">🔒 Secure sign-in — your dashboard is one click away.</p>
      </div>
    </div>
  );
}

export default AccessDenied;
